/**
 * 采购订单URL
 */
const purchaseOrderApi={
    addOrderUrl:'/purchasemng/purchaseOrder/add',
    searchPurchaseOrderUrl:'/purchasemng/purchaseOrder/list',
    loadPurchaseOrderUrl:'/purchasemng/purchaseOrder/select',
    modifyPurchaseOrderUrl:'/purchasemng/purchaseOrder/modify',
    purchaseOrderReapUrl:'/purchasemng/purchaseRec/add',
    receiptOrderUrl:'/purchasemng/purchaseOrder/receipt',//采购订单-采购订单收货
    returnsUrl:'/purchasemng/purchaseOrder/returns'//采购订单-采购订单退货    

}

export {
    purchaseOrderApi
}